<script lang="ts">
	import Tab, { Label } from '@smui/tab/styled';
	import TabBar from '@smui/tab-bar/styled';
	import { onMount } from 'svelte';
	import Choices from 'choices.js';

	let keyedTabs = [
		{
			k: 1,
			icon: 'code',
			label: 'Segment',
			selectOptions: []
		}
	];

	let choices: any;
	let element2: HTMLInputElement;

	onMount(() => {
		element2 = document.querySelector('.multiple-input2') as HTMLInputElement;

		element2.addEventListener(
			'change',
			function () {
				dmpSegment = { value: element2.value, label: 'label' };
			},
			false
		);

		choices = new Choices(element2);
	});

	let keyedTabsActive = keyedTabs[0];
	export let dmpSegment: { value: string; label: string };
</script>

<section>
	<div>
		<TabBar tabs={keyedTabs} let:tab bind:active={keyedTabsActive}>
			<Tab
				{tab}
				indicatorSpanOnlyContent={true}
				tabIndicator$transition="fade"
				type="button"
				on:click={() => {
					dmpSegment = { value: '', label: '' };
				}}
			>
				<Label>{tab.label}</Label>
			</Tab>
		</TabBar>
		<div class="lookalike-select-wrap">
			<div class="select-wrap">
				<input
					type="text"
					class={'multiple-input2'}
				/>
			</div>
		</div>
	</div>
</section>

<style>
	.lookalike-select-wrap {
		/*  background-color: white;*/
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex: 1;
		padding: 20px;
		padding-top: 30px;
	}
	.select-wrap {
		display: flex;
		flex: 1;
		flex-direction: column;
	}
</style>
